// Resolve an avatar value that may be an uploaded image (relative /uploads/...
// or absolute URL) into a usable <img src>. Emoji avatars are returned as-is;
// callers gate on isImageIcon() before using this for an <img>.
const SERVER_URL = process.env.REACT_APP_SERVER_URL || '';

export function avatarImageSrc(value) {
  if (typeof value !== 'string') return '';
  return value.startsWith('http') ? value : `${SERVER_URL}${value}`;
}

export default avatarImageSrc;
